module.exports = __webpack_public_path__ + "24_tvcg.jpg?accb6fdc0cce37fbbf2320714d21138d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/24_tvcg.jpg
// module id = 213
// module chunks = 0